import { render } from "./AiDialog.vue?vue&type=template&id=7e8b6b40&scoped=true"
import script from "./AiDialog.vue?vue&type=script&lang=js"
export * from "./AiDialog.vue?vue&type=script&lang=js"

import "./AiDialog.vue?vue&type=style&index=0&id=7e8b6b40&scoped=true&lang=scss"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e8b6b40"]])

export default __exports__